const XSvg = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_16080_11231"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="34"
      height="34"
    >
      <path d="M0.302002 0.380127H33.302V33.3801H0.302002V0.380127Z" fill="white" />
    </mask>
    <g mask="url(#mask0_16080_11231)">
      <path
        d="M5.79159 1.09888H27.8124C28.4426 1.09888 29.052 1.21867 29.6405 1.46346C30.2239 1.70304 30.7395 2.04679 31.1874 2.49471C31.6353 2.94263 31.9791 3.45825 32.2239 4.04679C32.4635 4.63013 32.5833 5.2395 32.5833 5.86971V27.8905C32.5833 28.5208 32.4635 29.1301 32.2239 29.7187C31.9791 30.302 31.6353 30.8176 31.1874 31.2655C30.7395 31.7135 30.2239 32.0572 29.6353 32.302C29.052 32.5416 28.4426 32.6666 27.8072 32.6666H5.79679C5.16138 32.6666 4.552 32.5416 3.96867 32.302C3.38534 32.0572 2.86971 31.7135 2.42179 31.2655C1.97388 30.8176 1.62492 30.302 1.38533 29.7187C1.14054 29.1301 1.02075 28.5208 1.02075 27.8905V5.86971C1.02075 5.2395 1.14054 4.63013 1.38533 4.04679C1.62492 3.45825 1.97388 2.94263 2.41658 2.49471C2.8645 2.04679 3.38534 1.70304 3.96867 1.46346C4.552 1.21867 5.16138 1.09888 5.79159 1.09888Z"
        stroke="black"
        strokeWidth="1.43478"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M20.6666 16.8801L26.0155 7.6145C26.0468 7.56242 26.0624 7.49992 26.0937 7.44263H21.0728L16.802 14.8489L12.526 7.44263H7.50513C7.53638 7.49992 7.552 7.56242 7.58325 7.6145L12.9374 16.8801L7.58846 26.1458C7.55721 26.203 7.53638 26.2655 7.51034 26.3228H12.5312L16.802 18.9166L21.078 26.3228H26.0989C26.0676 26.2655 26.052 26.203 26.0208 26.1458L20.6666 16.8801Z"
      stroke="black"
      strokeWidth="1.43478"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default XSvg;
